import React, { useEffect, useState } from 'react'
import { Modal, Typography, Button, notification } from 'antd'
import { LockOutlined } from '@ant-design/icons'
import { isUserLoggedIn } from 'services/utils'
import { logoutUser } from 'utils'
import {
  SESSION_FREEZE_EVENT,
  DEFAULT_FREEZE_MESSAGE,
  freezeSession,
  isSessionFrozen,
  clearSessionFrozenFlag,
  beginSessionTeardown,
} from 'utils/sessionFreeze'
import { subscribeToSessionFreeze, disconnectNotificationSocket } from 'socket'

const { Text } = Typography

const SessionFreezeGuard = () => {
  const [freezeMessage, setFreezeMessage] = useState(null)

  useEffect(() => {
    if (!isUserLoggedIn()) return undefined

    if (isSessionFrozen()) {
      // Widgets mounted below this guard already fired their calls; silence the 401s they
      // are about to get and explain the sign-out once, instead of an unactionable error.
      beginSessionTeardown()
      clearSessionFrozenFlag()
      disconnectNotificationSocket()
      notification.info({
        message: 'Session updated',
        description:
          "Your organization's configuration was updated. Please sign in again to continue.",
      })
      logoutUser()
      return undefined
    }

    const onWindowFreeze = (event) => {
      setFreezeMessage(event.detail?.message || DEFAULT_FREEZE_MESSAGE)
    }
    window.addEventListener(SESSION_FREEZE_EVENT, onWindowFreeze)

    const onSocketFreeze = (payload) => {
      freezeSession(payload?.message || DEFAULT_FREEZE_MESSAGE)
    }
    const unsubscribe = subscribeToSessionFreeze({ onFreeze: onSocketFreeze })

    return () => {
      window.removeEventListener(SESSION_FREEZE_EVENT, onWindowFreeze)
      unsubscribe()
    }
  }, [])

  return (
    <Modal
      visible={Boolean(freezeMessage)}
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer={null}
      centered
      zIndex={2000}
    >
      <div style={{ textAlign: 'center', padding: '16px 0' }}>
        <LockOutlined style={{ fontSize: 32, marginBottom: 16 }} />
        <Typography.Title level={4}>Session Locked</Typography.Title>
        <Text>{freezeMessage}</Text>
        <div style={{ marginTop: 24 }}>
          <Button type="primary" onClick={() => window.location.reload()}>
            Refresh Page
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default SessionFreezeGuard
